import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Link
} from "react-router-dom";
import App from './App';
import W3skull from './W3skull';
import MyTable from './Mytable';
import TakeTheShoot from './takeTheShoot';
import mailer from './mailer';
import mailercl from './mailercl';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from "./react-auth0-spa";
import config from "./auth_config.json";
import history from "./utils/history";

// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
  <React.StrictMode>
    <Router>
      <div>
        <ul>
          <li>
            <NavLink exact to="/" activeClassName="active" >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/w3skull" activeClassName="active" >
              w3skull
            </NavLink>
          </li>
          <li>
            <NavLink to="/mytable" activeClassName="active" >
              mytable
            </NavLink>
          </li>
          <li>
            <NavLink to="/taketheshoot" activeClassName="active" >
              taketheshoot
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" activeClassName="active" >
              contact
            </NavLink>
          </li>
          <li>
            <NavLink to="/contactcl" activeClassName="active" >
              contactcl
            </NavLink>
          </li>
        </ul>
        <Switch>
          <Route exact path="/" component={App} />
          <Route path="/w3skull" component={W3skull} />
          <Route path="/mytable" component={MyTable} />
          <Route path="/taketheshoot" component={TakeTheShoot} />
          <Route path="/contact" component={mailer} />
          <Route path="/contactcl" component={mailercl} />
        </Switch>
      </div>      
    </Router>
    {/* <App />
    <W3skull />
    <MyTable /> */}
  </React.StrictMode>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
